import React from 'react'
import PropTypes from 'prop-types'
import Spinner from '../common/Spinner';
import classnames from "classnames";

const Report5 = ({ tableData, showOPK, showOPKtoggle, refresh }) => {
  const valueConvert = (val) => {
    return Number(val).toFixed(2).replace(".",",")
  }

  const getHeader = () => {
    return ['Numer konta zespołu 4','Nazwa konta zespołu 4', 'Wartość kosztu [zł]','Udział w koszcie całkowitym OPK [%]']
  }
  
  const [isSorted, setIsSorted] = React.useState('Numer konta zespołu 4')
  const [isSortedDesc, setIsSortedDesc] = React.useState(false)
  const toggleSort = (sortBy) => {
    if(isSorted===sortBy){setIsSortedDesc(!isSortedDesc)}else{setIsSorted(sortBy)}
  }

  const getChildrenRow = (children ) => {
    return (Object.entries(children).map(([opk, item], i) => {
      return (<>
        {opk==="Suma"? <tr key={opk} className='rt-tr'>
          <td className='rt-td'  style={{ flex:"0 0 50%", borderRight:"1px solid #dee2e6" }} >{opk}</td>
          {/* <td className='rt-td'></td> */}
          <td className='rt-td' style={{borderLeft:"0",borderRight:"1px solid #dee2e6"}}>{valueConvert(item['WARTOŚĆ KOSZTU [ZŁ]'])}</td>
          <td className='rt-td' style={{ borderLeft:"0" }}>{item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]']}</td>
        </tr>:<><tr key={opk} className='rt-tr '>
          <td className='rt-td' onClick={()=>showOPKtoggle(opk)} style={{cursor: 'pointer'}}>
            {opk.includes('-')&&<i className="nc-icon nc-minimal-right" style={{marginRight: '5px', marginLeft: `${(opk.split('-').length-2)*15}px`}}></i>}
            {opk}
          </td>
          <td className='rt-td'>{item['name']}</td>
          <td className='rt-td'>{valueConvert(item['WARTOŚĆ KOSZTU [ZŁ]'])}</td>
          <td className='rt-td'>{valueConvert(item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])}</td>
        </tr>
        {item['children']!==undefined && showOPK[opk] && getChildrenRow(item['children'])}</>}
      </>)
    }))
  }

  if(tableData){
    return (<>
        {/* <table className='table table-border' style={{marginBottom: '0'}}>
          <tbody className=''> */}
            {Object.entries(tableData).map(([opk, item], i) => {
              return (<React.Fragment key={'rep5_'+i}>
                {opk!=="Suma"&& 
                  // <tr style={{fontWeight: 'bold'}} className='tryColor'>
                  //   <td colSpan='2'> {opk} </td>
                  //     <td className='rightAlignCell'>{valueConvert(item['WARTOŚĆ KOSZTU [ZŁ]']).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')}</td>
                  //     <td className='rightAlignCell'>{valueConvert(item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])}%</td>
                  // </tr>:
                <>
                  <tr key={opk} className='rt-tr tryColor'>
                    <td className='rt-td' onClick={()=>showOPKtoggle(opk)} style={{cursor: 'pointer'}}>
                      {showOPK[opk]?<i className="nc-icon nc-minimal-down" style={{marginRight: '5px'}}></i>:<i className="nc-icon nc-minimal-right" style={{marginRight: '5px'}}></i>}
                      {opk}
                    </td>
                    <td className='rt-td '>{item['name']}</td>
                    <td className='rt-td rightAlignCell' >{valueConvert(item['WARTOŚĆ KOSZTU [ZŁ]']).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')}</td>
                    <td className='rt-td rightAlignCell' >{valueConvert(item['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])}%</td>
                  </tr>
                  {item['children']!==undefined && showOPK[opk] && 
                    Object.entries(item['children']).map(([opk2, item2], i2) => {
                      return (
                       <tr key={opk2}  className='tryColor'>
                          <td className='rt-td'>
                            <span style={{marginLeft: '20px'}}>{opk2}</span>
                          </td>
                          <td className='rt-td '>{item2['name']}</td>
                          <td className='rt-td rightAlignCell'>{valueConvert(item2['WARTOŚĆ KOSZTU [ZŁ]']).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')}</td>
                          <td className='rt-td rightAlignCell'>{valueConvert(item2['UDZIAŁ W KOSZCIE CAŁKOWITYM OPK [%]'])}%</td>
                        </tr>
                      )
                    })
                  }
                </>}
              </React.Fragment>)
            })}
          {/* </tbody>
        </table> */}
    </>)
  }else{
    return <Spinner />
  }
}
Report5.propTypes = {
  tableData: PropTypes.object,
  showOPK: PropTypes.object,
  showOPKtoggle: PropTypes.func,
  refresh: PropTypes.bool.isRequired,
}
export default Report5
